import React from "react";
import {
  SegmenSettingstTitle,
  SegmentHeaderContainer,
  SegmentSettingsIcon,
} from "../SegmentSettings.styled";
import { Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ASSETS } from "../../../utils/config";

const SegmentHeader = ({ handleDeleteSegment, title = "Segment Settings" }) => {
  return (
    <SegmentHeaderContainer>
      <Stack gap={"5px"} direction={"row"} alignItems={"center"}>
        <SegmentSettingsIcon src={ASSETS.SegmentSettingsIcon} />
        <SegmenSettingstTitle>{title}</SegmenSettingstTitle>
      </Stack>

      <Stack gap={"5px"} direction={"row"}>
        <ContentCopyIcon width={"24px"} height={"24px"} cursor={"pointer"} />
        <DeleteOutlineIcon
          width={"24px"}
          height={"24px"}
          color="error"
          cursor={"pointer"}
          onClick={handleDeleteSegment}
        />
      </Stack>
    </SegmentHeaderContainer>
  );
};

export default SegmentHeader;
